import { useEffect } from "react";
import React from "react"
import { Outlet } from "react-router-dom";
import { useAuth } from "../Context/AuthenticateProvider";
import Layout from "../Partials/Layout";

const PrivateRouters = ({ children }) => {
    const { isAuthenticated } = useAuth();
    useEffect(() => {
        if (!isAuthenticated) {
            window.location.href = '/login'
        }
    }, [isAuthenticated]);

    return (
        <React.Fragment>
            {isAuthenticated && (
                <Layout>
                    {children}
                    <Outlet />
                </Layout>
            )}
        </React.Fragment>
    );
}

export default PrivateRouters;
